import { SectionHeader, TestimonialCard } from './shared';
import { Testimonial } from './types';

// Testimonials data
const testimonials: Testimonial[] = [
    {
        quote: "BerryBabies' smart diaper has been a game-changer for our family. No more middle-of-the-night guessing games!",
        author: "Sarah M., Mother of 2",
        rating: 5
    },
    {
        quote: "As a pediatrician and new mom, I appreciate the health analytics that help me monitor my baby's hydration patterns.",
        author: "Dr. Jessica T., Pediatrician",
        rating: 5
    },
    {
        quote: "The alerts are accurate and timely. The sensor is so comfortable my baby doesn't even notice it's there.",
        author: "Michael R., Father of twins",
        rating: 4
    }
];

export const Testimonials = () => {
    return (
        <section className="rounded-2xl bg-gradient-to-br from-blue-100/80 to-sky-100/80 dark:from-blue-900/20 dark:to-sky-900/20 py-24 px-4">
            <div className="container mx-auto py-4">
                <SectionHeader 
                    badgeText="Parent Approved"
                    badgeClasses="bg-primary/10 text-primary hover:bg-primary/20"
                    title="What Parents Are Saying"
                    description="Join thousands of happy families who trust BerryBabies"
                />
                
                <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                    {testimonials.map((testimonial, index) => (
                        <TestimonialCard key={index} testimonial={testimonial} />
                    ))}
                </div>
            </div>
        </section>
    );
};